export const CALENDAR_GRID_CARD_TRIGGER_OFFSET = 8

export const CALENDAR_GRID_CARD_TRIGGER_SHIFT_PADDING = 8

export const CALENDAR_GRID_CARD_TRIGGER_ROLE = 'dialog'
